var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    _vm._b(
      {
        staticClass: "lexon-tooltip-container",
        attrs: { "content-class": _setup.positionClass },
        scopedSlots: _vm._u(
          [
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b({ staticClass: "activator" }, "div", attrs, false),
                      on
                    ),
                    [
                      _vm._t("activator-element", function () {
                        return [
                          _c("span", {
                            class: [_vm.icon, "tooltip-icon"],
                            on: { click: (event) => _vm.action(event) },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      },
      "v-tooltip",
      _setup.tooltipPosition,
      false
    ),
    [
      _c("p", {
        staticClass: "lefebvre-tooltip-message",
        domProps: { innerHTML: _vm._s(_vm.message) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }